module.exports = __webpack_public_path__ + "img/4.24ca36d5.png";